const flow = require('lodash/fp/flow');
const map = require('lodash/fp/map');
const filter = require('lodash/fp/filter');
const reduce = require('lodash/fp/reduce');
const uniq = require('lodash/fp/uniq');

module.exports = angular.module('msi.shipments.shipmentService', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/subscriptions/service')
]).name;

const inject = ['apiService', '$q', 'ogsdk.orderService', 'subscriptionService'];

function shipmentsApiSvc(apiService, $q, orderService, subscriptionService) {
  this.setPayment = function(shipmentId, paymentId) {
    return orderService.changePayment(shipmentId, paymentId);
  };

  this.setShipping = function(shipmentId, addressId) {
    return orderService.changeShippingAddress(shipmentId, addressId);
  };

  function doSequentiallyForAllSubscriptions(shipment, fn) {
    return flow(
      map(item => item.subscriptionId),
      filter(it => it),
      uniq,
      reduce(
        (acc, subId) => acc.then(
          () => fn(subId),
          () => fn(subId)
        ),
        $q.when()
      )
    )(shipment.items);
  }

  this.setShippingForSubscriptions = function(shipment, addressId) {
    function setShippingForItem(subscriptionId) {
      return subscriptionService.setShipping(subscriptionId, addressId);
    }

    return this.setShipping(shipment.publicId, addressId)
      .then(() => doSequentiallyForAllSubscriptions(shipment, setShippingForItem));
  };

  this.setPaymentForSubscriptions = function(shipment, paymentId) {
    function setPaymentForItem(subscriptionPublicId) {
      return subscriptionService.setPayment(subscriptionPublicId, paymentId);
    }

    return this.setPayment(shipment.publicId, paymentId)
      .then(() => doSequentiallyForAllSubscriptions(shipment, setPaymentForItem));
  };
}

shipmentsApiSvc.$inject = inject;

angular.module(module.exports).service('shipmentService', shipmentsApiSvc);
